import { render, staticRenderFns } from "./update-vaccin.vue?vue&type=template&id=7f1387a2"
import script from "./update-vaccin.vue?vue&type=script&lang=js"
export * from "./update-vaccin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports